<template>
    <modal-base class="fzg-about-partner-modal" @hide-modal="hideModal">
        <template slot="header"> </template>
        <template slot="content">
          <div class="partner-intro">
            <div class="p-left">
              <img class="photo" :src="partnerData[partnerIndex].photo" alt="">
            </div>
            <div class="p-right">
              <div class="name">{{partnerData[partnerIndex].name}}</div>
              <div class="title">{{partnerData[partnerIndex].title}}</div>
              <div class="intro">{{partnerData[partnerIndex].intro}}</div>
            </div>
          </div>
        </template>
    </modal-base>
</template>

<script>
import ModalBase from '../widgets/ModalBase.vue'

export default {
    mixins: [],
    props: ['partnerIndex'],
    data () {
      return {
        partnerData: [
          {
            name: '李晶',
            title: '凡卓集团创始人兼CEO',
            intro: '2014年创立凡卓集团（曾用名：小饭桌），结合旗下财务顾问、直接投资、研究咨询、媒体平台、培训服务等业务，形成行业独有领先的生态体系，为集团奠定了长期发展的理念。在其带领下，凡卓集团已累计帮助超600家创业公司完成融资，交易总额超800亿元。\n\n创办凡卓集团前，曾就职于华兴资本，拥有十余年投融资经验，代表融资案例包括滴滴出行、友盟、景略半导体、瀚博半导体、蓝箭航天、太美医疗、神策数据、数美科技、摩尔元数、芯驰科技、核桃编程、乐摇摇、怪兽充电等。\n\n李晶女士本科毕业于北京大学，拥有北京大学经济学、法学双学士学位，清华五道口EMBA。',
            photo: 'https://static-image.xfz.cn/1686454314830/p1.jpg'
          },
          {
            name: '张筱燕',
            title: '小饭桌创投合伙人',
            intro: '2020年加入凡卓集团，担任凡卓集团、小饭桌创投（原凡创资本）合伙人，前梅花创投联合创始人、执行总裁。专注早期投资，一直坚持以创业的心态做投资，陪伴创业者从平凡到卓越。\n\n张筱燕女士成功投资了51社保、福佑卡车、理想汽车、小牛电动、唱吧、马帮erp、致趣百川、美术宝、珞石机器人、爱数智慧、攀藤科技、增广智能、脉络能源、红云生物等。\n\n张筱燕女士拥有清华大学硕士、北京大学学士学位。',
            photo: 'https://static-image.xfz.cn/1686454323746/p2.jpg'
          },
          {
            name: '张琦',
            title: '运营合伙人',
            intro: '2015年加入凡卓集团，担任运营合伙人，负责集团整体中后台运营管理：不断推动平台能力提升，在负责管理体系搭建、业务运营分析、中后台制度规则建设及数字化管理建设等重要工作上做出突出贡献。\n\n加入凡卓集团前，曾先后就职于普华永道会计师事务所及天灏资本，参与过汽车、化工、新材料等行业上市公司的IPO、尽职调查工作，此后作为卖方证券分析师覆盖美股中概股公司。\n\n张琦女士拥有对外经济贸易大学经济学学士学位。',
            photo: 'https://static-image.xfz.cn/1686454333282/p3.jpg'
          },
          {
            name: '王梦菲',
            title: '凡卓资本合伙人',
            intro: '2017年加入凡卓集团，担任凡卓资本合伙人，核心关注工业、先进制造、企业服务、 SaaS、 AI大数据等方向的应用科技。\n\n在凡卓资本就职的5年中，王梦菲女士帮助神策数据、数美科技、雪浪云、蔚领时代、智布互联、摩尔元数、塬数科技等多家优质企业获得投资。\n\n王梦菲女士毕业于美国南加州大学(University of Southern California )，获经济学硕士学位。',
            photo: 'https://static-image.xfz.cn/1686454340648/p4.jpg'
          },
        ]
      }
    },
    methods: {
      hideModal () {
        this.$emit('hide-modal')
      },
    },
    mounted(){
    },
    components:{ModalBase}
}
</script>

<style lang="scss">
.fzg-about-partner-modal {
  .modal {
    border-radius: 8px;
    width: 1100px;
    height: 500px;
    // background: #232323 !important;
    background: #363636 !important;
    header {
        // border-bottom: 1px solid #c7cfdd;
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        margin-right: 0 !important;
        i.icon-close {
            width: 44px !important;
            height: 44px !important;
            margin-top: 10px !important;
            background: {
                image: url("../../assets/img/pc/circle-close.png");
                repeat: no-repeat;
                size: 100%;
            }
        }
        .training-modal-title {
          color: white;
          position: relative;
          // border: 1px solid #ccc;
          height: 100px;
          float: left;
          width: 800px;
          overflow: hidden;
          img {
            position: absolute;
            display: block;
            width: 80px;
            top: 20px;
            left: 10px;
          }
          span {
            position: absolute;
            display: block;
            top: 36px;
            left: 40px;
          }
        }
    }
  }
  .content {
    clear: both;
    font-size: 14px;
    color: white;
    font-size: 14px;
    height: 410px;
    padding: 0px 40px 0px;
    margin: 0 30px;
    line-height: 1.5;
    white-space: pre-wrap;
    overflow: scroll;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .partner-intro {
      .p-left {
        display: inline-block;
        // border: 1px solid red;
        width: 300px;
        height: 400px;
        margin-right: 20px;
        .photo {
          width: auto;
          height: 100%;
        }
      }
      .p-right {
        // border: 1px solid red;
        display: inline-block;
        vertical-align: top;
        width: 660px;
        height: 400px;
        .name {
          font-size: 24px;
          color: #d7ad78;
          line-height: 1;
          margin-top: 10px;
        }
        .title {
          font-size: 16px;
          color: #d7ad78;
          margin-top: -10px;
        }
        .intro {
          margin-top: 20px;
          font-size: 14px;
          line-height: 1.8;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// FzgAboutPartnerModal.vue?34be57ac